import { html } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../common/mixin';
export const tilesTemplate = html `<slot></slot>`;
export class TilesComponent extends ChameleonElementMixin(FoundationElement) {
}
